module.exports = require("@scure/bip39/wordlists/english");